// A banana plant: a short stout green pseudo-stem with a few big broad drooping
// leaves fanning out from the top. Ported 1:1 from age-of-mcp's classic
// tree-banana.ts, restoring its radial leaf loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.1, 0.13, 0.8, 7),
      color: "#5d7d3a", position: [0, 0.4, 0] },
  ];
  const N = 5;
  for (let i = 0; i < N; i++) {
    const a = (i / N) * Math.PI * 2;
    parts.push({
      geometry: new THREE.BoxGeometry(0.7, 0.05, 0.34),
      color: i % 2 ? "#4f9e3c" : "#62b84a",
      position: [Math.cos(a) * 0.34, 0.82, Math.sin(a) * 0.34],
      rotation: [0, -a, -0.22],
    });
  }
  return parts;
}

export const treeBanana = defineModel({
  id: "tree-banana",
  batchId: "standard",
  name: "Tree banana",
  tags: ["scenery","tree","banana","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree banana.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.5,
  parts: () => partsFor(),
  animations: [],
});
